import { AxiosResponse } from "axios";
import { Services } from "../../../services";
import apiClient, { ApiResponse } from "./apiClient";

export interface SearchAutocompleteRequestBody {
    language: string;
    query: string;
    search_after?: number[];
}

type SearchResultEntry = {
    id: number;
    name: string;
    url: string;
    image_url: string;
    sort: Array<number>;
    highlight: Record<string, string[]>;
    included_keywords: string;
};

type SearchResultsStats = {
    total: number;
};

export type SearchResults = {
    data: SearchResultEntry[];
    stats: SearchResultsStats;
};

export interface SearchAutocompleteProductsResponse {
    version: string;
    searchResults: SearchResults;
}

export interface SearchAutocompleteCategoriesResponse {
    version: string;
    searchResults: SearchResults;
}

export interface SearchAutocompleteHealthcheckResponse {
    version: string;
    health: boolean;
}

export default class SearchApiService {
    private endpoint = "https://api-test.uderman.sk/api/v1";
    constructor(private _services: Services) {}

    async searchAutocomplete(
        entity_type: "product" | "category",
        params: any = {},
        requestBody: SearchAutocompleteRequestBody
    ): Promise<ApiResponse<SearchAutocompleteCategoriesResponse>> {
        let result;
        if (entity_type === "product") {
            result = await this.searchAutocompleteProducts(params, requestBody);
        } else {
            result = await this.searchAutocompleteCategories(params, requestBody);
        }
        return result;
    }

    async searchAutocompleteProducts(
        params: any = {},
        requestBody: SearchAutocompleteRequestBody
    ): Promise<ApiResponse<SearchAutocompleteProductsResponse>> {
        return await apiClient.post(this.endpoint + "/search/autocomplete/products", requestBody, {}, params);
    }

    async searchAutocompleteCategories(
        params: any = {},
        requestBody: SearchAutocompleteRequestBody
    ): Promise<ApiResponse<SearchAutocompleteCategoriesResponse>> {
        return await apiClient.post(this.endpoint + "/search/autocomplete/categories", requestBody, {}, params);
    }

    async searchAutocompleteHealthcheck(params: any = {}): Promise<ApiResponse<SearchAutocompleteHealthcheckResponse>> {
        return await apiClient.get(this.endpoint + "/search/autocomplete/healthcheck", params);
    }
}
